import { collect } from '@/analytics';
import { collectTrackData } from '@/utils/Tracker/tracker';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    HOME_PORTAL: 'Home-Portal',
  },
  ACTION: {
    SUPERGATOR: 'SuperGator',
  },
  LABEL: {
    AGENTS_BANNER_CTA: 'Teste 30 dias grátis',
  },
};

const events = {
  heroCtaClick: {
    campaign: EVENT.CATEGORY.HOME_PORTAL,
    action: EVENT.ACTION.SUPERGATOR,
  },
  agentsBannerCtaClick: {
    campaign: EVENT.CATEGORY.HOME_PORTAL,
    action: EVENT.ACTION.SUPERGATOR,
    label: EVENT.LABEL.AGENTS_BANNER_CTA,
  },
};

const heroCtaClick = ({ label }) => {
  const event = { ...events.heroCtaClick, label };

  collect({
    event: EVENT.NAME,
    gaEventCategory: event.campaign,
    gaEventAction: event.action,
    gaEventLabel: event.label,
  });

  collectTrackData(event);
};

const agentsBannerCtaClick = () => {
  const event = { ...events.agentsBannerCtaClick };

  collect({
    event: EVENT.NAME,
    gaEventCategory: event.campaign,
    gaEventAction: event.action,
    gaEventLabel: event.label,
  });

  collectTrackData(event);
};

const supergatorAnalytics = {
  heroCtaClick,
  agentsBannerCtaClick,
};

export default supergatorAnalytics;
